import React from 'react'

export type SwitchProps = {
	checked: boolean
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	disabled?: boolean
	className?: string
	id?: string
}

const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled = false, className = '', id }) => {
	return (
		<label className={`inline-flex items-center cursor-pointer select-none ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'} ${className}`}>
			<input
				id={id}
				type="checkbox"
				className="sr-only"
				checked={checked}
				onChange={onChange}
				disabled={disabled}
			/>
			<span
				className={`relative inline-flex h-6 w-10 items-center rounded-full transition-colors duration-200 ${checked ? 'bg-brand-600' : 'bg-black/20'}`}
				aria-hidden="true"
			>
				<span
					className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ${checked ? 'translate-x-5' : 'translate-x-1'}`}
				/>
			</span>
		</label>
	)
}

export default Switch

